import { useFormikContext } from 'formik'
import CloseIcon from 'icons/close'
import UploadIcon from 'icons/upload'
import { useState } from 'react'
import { Cropper } from 'react-cropper'
import 'cropperjs/dist/cropper.css'

function CDImage({ name, label, className }) {
  const formik = useFormikContext()
  const [image, setImage] = useState(formik.values[name])

  const handleImage = (e) => {
    e.preventDefault()
    let files
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      setImage(reader.result)
      formik.setValues({
        ...formik.values,
        [name]: reader.result,
        [name + 'Name']: files[0].type,
      })
    }
    reader.readAsDataURL(files[0])
  }

  const handleClose = () => {
    setImage()
    formik.setFieldValue(name, '')
    formik.setFieldValue(name + 'Name', '')
    if (document.getElementById(name)) {
      document.getElementById(name).value = ''
    }
  }

  const handleCropEnd = (e) => {
    try {
      const croppedCanvas = e.target.cropper.getCroppedCanvas();
      if (croppedCanvas) {
        formik.setFieldValue(name, croppedCanvas.toDataURL());
      }
    } catch (err) {
      console.warn('Canvas crop error (likely CORS):', err);
    }
  }

  return (
    <div class={`tw-grow tw-flex tw-flex-col tw-gap-[7px] ${className}`}>
      <div className='tw-text-[#4A403A] tw-text-[15px] md:tw-text-[13px] tw-font-[500] tw-heading-[20px]'>
        {label}
      </div>
      <div className='tw-bg-[#F2ECE7] tw-rounded-[5px] tw-min-h-[55px] md:tw-min-h-[40px] tw-px-[11px] tw-flex tw-items-center'>
        <div className='tw-w-full tw-max-w-[80vw]'>
          <input
            type='file'
            id={name}
            accept='image/png, image/jpeg, image/jpg'
            onChange={handleImage}
            hidden
          />
          {image ? (
            <>
              <div class='tw-cursor-pointer tw-h-[40px] tw-flex tw-items-center tw-text-[#B9ADA5] tw-justify-between'>
                <div class='tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-[16px] tw-placeholder-gray-300 md:tw-text-[14px] tw-heading-[20px] tw-text-black'>
                  {document.getElementById(name)?.files?.[0]?.name || formik.values[name + 'Name'] || label + ' Image'}
                </div>
                <CloseIcon onClick={handleClose} />
              </div>
              <div className='tw-bg-white tw-mb-[10px] tw-rounded-[5px] tw-overflow-hidden'>
                {typeof image === 'string' && image.startsWith('http') ? (
                  <img src={image} alt="preview" style={{ width: '100%' }} />
                ) : (
                  <Cropper
                    src={image}
                    cropend={handleCropEnd}
                    style={{ width: '100%' }}
                    zoomTo={0.8}
                    autoCropArea={0.9}
                  />
                )}
              </div>
            </>
          ) : (
            <label
              htmlFor={name}
              className='tw-cursor-pointer tw-h-[40px] tw-flex tw-items-center tw-text-[#B9ADA5] tw-justify-between'
            >
              <div className='tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-[16px] tw-placeholder-gray-300 md:tw-text-[14px] tw-heading-[20px] tw-text-[#B9ADA5]'>
                .png or .jpeg fields only
              </div>
              <UploadIcon />
            </label>
          )}
        </div>
      </div>
    </div>
  )
}

export default CDImage
